import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { environment } from './environments/environment';
import { StorageModule } from '@libs/core/storage';
import { StatusBarModule } from '@libs/ui/status-bar';
import { ColorModule } from '@libs/core/color';
import { NavigationBarModule } from '@libs/ui/navigation-bar';
import { EnvironmentBannerModule } from '@libs/ui/environment-banner';
import { MonitoringModule } from '@libs/core/monitoring';
import { PrivacyPolicyModule } from '@libs/core/privacy-policy';
import { PtApiModule, UserService } from '@libs/core/pt-api';
import { AuthModule } from '@libs/core/auth';
import { PlatformDetectionService, SharedModule } from '@libs/util/shared';
import { initApp } from './app/app.initializer';
import { httpInterceptorsProviders } from './app/interceptors/all';
import { AuthPtModule, AuthService } from '@libs/core/auth-pt';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      IonicModule.forRoot(),
      AppRoutingModule,
      StorageModule.forRoot(),
      AuthModule.forRoot({
        authenticateOptions: environment.auth,
      }),
      PrivacyPolicyModule.forRoot({
        privacyPolicyUrl: environment.privacyPolicyUrl,
        acceptPrivacyPolicyService: UserService,
      }),
      AuthPtModule.forRoot(),
      StatusBarModule.forRoot(),
      ColorModule.forRoot(),
      NavigationBarModule.forRoot(),
      SharedModule,
      PtApiModule.forRoot({ rootUrl: environment.apiUrl }),
      HttpClientModule,
      MonitoringModule.forRoot({
        appName: 'package-tracking',
        sentryDsn: environment.sentry.dsn,
        appVersion: environment.appVersion,
        appEnvironment: environment.appEnvironment,
        enable: environment.sentry.enable,
        sentryType: 'capacitor',
      }),
      EnvironmentBannerModule,
    ),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      multi: true,
      deps: [AuthService, PlatformDetectionService],
    },
    httpInterceptorsProviders,
  ],
}).catch((err) => console.error(err));
